import { CircularProgress } from "@mui/material";
import React from "react";

// From https://github.com/mui/material-ui/issues/9496#issuecomment-959408221
export function GradientCircularProgress() {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#FF1400" />
            <stop offset="100%" stopColor="#0F0E96" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
        size={"40px"}
      />
    </React.Fragment>
  );
}
